var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comunicaciones.length > 0)?_c('section',{staticClass:"modulos-comunicaciones"},[_c('h2',{staticClass:"titulo"},[_vm._v("Comunicaciones")]),_vm._v(" "),_c('div',{staticClass:"comunicaciones-list row-between"},_vm._l((_vm.comunicaciones),function(n,key){return _c('comunicacion-el',{key:key,attrs:{"data":n}})}),1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d21af088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/modulo-comunicaciones.vue
// module id = null
// module chunks = 